import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUSES, PRIORITIES, ASSIGNEES, SECTIONS } from "@/lib/api";
import { cn } from "@/lib/utils";

const RANGES = [
  { key: "all", label: "Tümü" },
  { key: "today", label: "Bugün" },
  { key: "upcoming", label: "Yaklaşan" },
  { key: "overdue", label: "Geciken" },
];

export const Filters = ({ filters, setFilters, showSection = true }) => {
  const set = (key) => (value) => setFilters((f) => ({ ...f, [key]: value }));

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {RANGES.map((r) => (
          <button
            key={r.key}
            type="button"
            data-testid={`filter-range-${r.key}`}
            onClick={() => set("range")(r.key)}
            className={cn(
              "h-9 rounded-xl border px-4 text-sm font-medium transition-colors duration-150",
              filters.range === r.key
                ? "border-navy bg-navy text-white dark:border-slate-100 dark:bg-slate-100 dark:text-navy"
                : "border-border bg-card text-muted-foreground hover:bg-muted hover:text-foreground"
            )}
          >
            {r.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
        {showSection && (
          <Select value={filters.section} onValueChange={set("section")}>
            <SelectTrigger className="sm:w-[170px]" data-testid="filter-section"><SelectValue placeholder="Bölüm" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tüm Bölümler</SelectItem>
              {SECTIONS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
        <Select value={filters.status} onValueChange={set("status")}>
          <SelectTrigger className="sm:w-[170px]" data-testid="filter-status"><SelectValue placeholder="Durum" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tüm Durumlar</SelectItem>
            {STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={filters.priority} onValueChange={set("priority")}>
          <SelectTrigger className="sm:w-[160px]" data-testid="filter-priority"><SelectValue placeholder="Öncelik" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tüm Öncelikler</SelectItem>
            {PRIORITIES.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={filters.assignee} onValueChange={set("assignee")}>
          <SelectTrigger className="sm:w-[180px]" data-testid="filter-assignee"><SelectValue placeholder="Sorumlu" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tüm Sorumlular</SelectItem>
            {ASSIGNEES.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
